import { ROOT_COMPNENT_ID, IComponentType, } from '.';
export const CONTENT_DOC_VERSION = 28;
export const initCnDoc = () => {
    return {
        version: CONTENT_DOC_VERSION,
        rootComponentId: ROOT_COMPNENT_ID,
        screenRelativeScaleType: 'absolute',
        hideScreenRelativeScaleTypeUI: true,
        projectColors: [],
        componentsById: {
            [ROOT_COMPNENT_ID]: {
                type: IComponentType.Root,
                children: [],
            }
        },
        mediaFilesById: {}
    };
};
